import { render, staticRenderFns } from "./FirmMemberMsgLayer.vue?vue&type=template&id=6313457a&scoped=true&"
import script from "./FirmMemberMsgLayer.vue?vue&type=script&lang=js&"
export * from "./FirmMemberMsgLayer.vue?vue&type=script&lang=js&"
import style0 from "./FirmMemberMsgLayer.vue?vue&type=style&index=0&id=6313457a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6313457a",
  null
  
)

export default component.exports